export default __webpack_public_path__ + "img/52341720c83451ae5adc4bf6a1582edb.svg";